// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const FlipVerticalOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"g","attrs":{"clip-path":"url(#clip0_473_23871)"},"children":[{"tag":"path","attrs":{"d":"M5.2 19.62l4.3-4.3 4.3 4.3H5.2zM13.8 4.03l-4.3 4.3-4.3-4.3h8.6z","fill":"currentColor","stroke":"currentColor"}},{"tag":"path","attrs":{"d":"M14.86 11.83H4.14","stroke-width":"1.5","stroke":"currentColor"}},{"tag":"path","attrs":{"d":"M18 14.92l-1.5-1.6-.13 4.14 4.13.12-1.5-1.6a5.85 5.85 0 00-2.54-9.91l-.04 1.5A4.4 4.4 0 0118 14.92z","fill":"currentColor"}}]},{"tag":"defs","attrs":{},"children":[{"tag":"clipPath","attrs":{"id":"clip0_473_23871"},"children":[{"tag":"path","attrs":{"d":"M0 0h24v24H0z","fill":"currentColor"}}]}]}]},"name":"flip-vertical","theme":"outlined"};

const FlipVerticalOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={FlipVerticalOutlinedSvg} />;
  FlipVerticalOutlined.displayName = 'FlipVerticalOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(FlipVerticalOutlined);
